// src/pages/reports/ReportsHub.jsx
import React from 'react';
import { Box } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';

export default function ReportsHub() {
  return (
    <Box>
      {/* Render only the active nested route (Sales / Opportunities / Call Again / Cancelled / Archive) */}
      <Box mt={0}>
        <Outlet />
      </Box>
    </Box>
  );
}
